import React from 'react'
import { useEffect, useState } from 'react';
import './FaultFirstPageCustom_Coral.css';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import NoData_Coral from '../../Driveanalysis_Coral/NoData_Coral';
import COmpBiDirTest_Coral from './FaultSecondPageChartsBidirRender_Coral';
import ChartLoader_Coral from '../../Driveanalysis_Coral/ChartLoader_Coral';

export default function FaultSecondPageBarCharts_Coral(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defaultNav, setDefaultNav] = useState("BCS");
  const [dataMain, setDataMain] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "268px" });
  const [topping, setTopping] = useState("Fault")
  const [toShow, setToShow] = useState(false)
  const [toCalculateFault, setToCalculateFault] = useState(0)

  const onRadioChange = e => {
    setTopping(e.target.value)
  }

const responceData = (data) => {
  let dataArray = [];

  // Total of all values
  let totalTime = data.reduce((acc, item) => acc + (item.NumOfTime?.value || 0), 0);
  let totalOcc = data.reduce((acc, item) => acc + (item.occ?.value || 0), 0);

  data.forEach((item) => {
    const signalName = item.key?.L4_Signal_Name?.toUpperCase() || 'UNKNOWN';

    const timeVal = item.NumOfTime?.value || 0;
    const occVal = item.occ?.value || 0;

    const male = totalTime > 0 ? (timeVal / totalTime) * 100 : 0;
    const female = totalOcc > 0 ? (occVal / totalOcc) * 100 : 0;

    dataArray.push({
      age: signalName,
      male: -male,
      female: female,
      orgLevalMale: timeVal.toString(),
      orgLevalFemale: occVal.toString(),
      signal_nm: item.key?.L4_Signal_Name,
      signal_desc: item.key?.Signal_value,
      signal_val: item.key?.Fault_Alarm_Value
    });
  });

  // Handle duplicates (same signal name with different fault values)
  for (let i = 0; i < dataArray.length; i++) {
    let count = 0;
    for (let j = i + 1; j < dataArray.length; j++) {
      if (dataArray[i].age === dataArray[j].age) {
        dataArray[j].age = `${dataArray[j].age}_${dataArray[j].signal_val}`;
        count = 1;
      }
    }
    if (count) {
      dataArray[i].age = `${dataArray[i].age}_${dataArray[i].signal_val}`;
    }
  }

  // Sort by `male` value ascending
  dataArray.sort((a, b) => a.male - b.male);

  setDataMain(dataArray);
};


  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU", "Cluster","BAS"];
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU === element);
      if (index === -1) {
        dataArr.push({
          key: { ECU: element },
          doc_count: 0,
          [chngKey]: { value: 0 }
        });
      }
    });
    return dataArr.sort((a, b) => a.key.ECU.localeCompare(b.key.ECU));
  }

  // const responceBarData = (data) => {
  //   const ecu = addECU(data, "occ")
  //   const foodBar = ecu.find(item => item.key.ECU === defaultNav);
  //   setToCalculateFault(foodBar.occ.value);
  // }
  const responceBarData = (data) => {
  const ecu = addECU(data, "occ");

  const foodBar = ecu.find(item => item.key.ecu_group === defaultNav);

  if (foodBar && foodBar.occ && typeof foodBar.occ.value === 'number') {
    setToCalculateFault(foodBar.occ.value);
  } else {
    console.warn(`No matching ECU group found for: ${defaultNav}`);
    setToCalculateFault(0); // fallback or default
  }
};

  useEffect(() => {
    if (topping === "Fault") {
      fetchData(
        {
          url: API_URL_MAIN + 'coral_fault_analysis/faultanalysis',
          body: { filterdata: gloablfilter, IND }
        },
        responceBarData
      );

      fetchData(
        {
          url: API_URL_MAIN + 'coral_fault_analysis/fleetLevalFault',
          body: { filterdata: gloablfilter,  defaultNav: defaultNav }
        },
        responceData
      );
    }
  }, [topping, defaultNav, props, gloablfilter, toShow, toCalculateFault]);

  function getNavTab(e, name) {
    setDefaultNav(name);
  }

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mgt-2">
      <div className="v-title chartbox3">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <div className="titlebg">Fault</div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6" style={{ textAlign: 'end' }}>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Fault" value="Fault" checked={topping === "Fault"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio1">Fault</label>
            </div>
          </div>
        </div>
        <div className="chartHGT">
          <div className="mt-2 mb-2">
            <div className="mt-3">
              <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                {["BCS", "MCU", "VCU", "DCDC", "OBC", "BMS", "Cluster","BAS"].map((name) => (
                  <li className="nav-item" key={name}>
                    <a
                      className={`nav-link ${defaultNav === name ? "active" : ""}`}
                      data-bs-toggle="tab"
                      href={`#${name}`}
                      onClick={(e) => getNavTab(e, name)}
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="tab-content">
                <div className='row' style={{ textAlign: 'right' }}>
                  <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                    <dt className="red"></dt>
                    <dd>Time Duration (mins)</dd>
                    <dt className="yellow" style={{ marginLeft: "5px" }}></dt>
                    <dd>Vehicle Count</dd>
                  </dl>
                </div>
                {["BCS", "MCU", "VCU", "DCDC", "OBC", "BMS", "Cluster","BAS"].map((name) => (
                  <div
                    key={name}
                    id={name}
                    className={`container tab-pane fade ${defaultNav === name ? "show active" : ""}`}
                  >
                    <br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD}>
                        {isLoading ? <ChartLoader_Coral /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Coral dataMain={dataMain} id={`chartdiv${name}`} /> :
                            <NoData_Coral />)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
